module.exports = __webpack_public_path__ + "static/tags-based-configuration_6-558f8d89121ebe7ea190eabd68eb90a0.png";